mutation updateSlotText($input: UpdateSlotTextInput!) {
  slot: updateSlotText(input: $input) {
    id
    platform
    topicId
    topicName
    scheduledLocal {
      date
      time
    }
    hint
    generatedText
    textChoices
    textStatus
    generationError
    status
    savedContentId
  }
}
